import { Settings } from '@mui/icons-material';

import { basicRoles } from '@/router/consts';
import 쇼핑몰_연동_설정_라우터 from '@/router/linkage/setting';
import 설정_메뉴_라우터 from '@/router/settings';
import 원클릭_판매확장_설정_라우터 from '@/router/settings/sale-platform-extension';

import { sellerMap } from '../../managementMaps';
import type { SidebarMenu } from '../../types';

// 설정 메뉴들
const 설정_메뉴들: SidebarMenu[] = [
  {
    title: sellerMap.index.title,
    path: sellerMap.index.path,
    icon: <Settings />,
    roles: basicRoles,
    childrenMenus: [
      ...설정_메뉴_라우터
        .filter(v => v.handle?.displayInSidebarMenu === true)
        .map((v): SidebarMenu => {
          return {
            title: v.handle?.title ?? '제목 없음',
            path: v.path ?? '/',
            display: true,
          };
        }),
      ...쇼핑몰_연동_설정_라우터
        .filter(v => v.handle?.displayInSidebarMenu === true)
        .map((v): SidebarMenu => {
          return {
            title: v.handle?.title ?? '제목 없음',
            path: v.path,
            display: true,
          };
        }),

      sellerMap['brand-group'],
      sellerMap['sales-management-advanced'],
      sellerMap['template'],

      ...원클릭_판매확장_설정_라우터
        .filter(v => v.handle?.displayInSidebarMenu === true)
        .map((v): SidebarMenu => {
          return {
            title: v.handle?.title ?? '제목 없음',
            path: v.path,
            display: true,
          };
        }),
    ],
  },
];

export default 설정_메뉴들;
